import React from 'react'
import { BrokenImageIcon } from '@/atoms/Icons/BrokenImageIcon'
import { ParagraphLG, ParagraphXL } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const LivestreamError: React.FC = () => {
  const { t } = useTranslate('livestream')

  return (
    <div className="relative h-[60vh] bg-black/80">
      <div className="absolute left-1/2 top-1/2 h-fit -translate-x-1/2 -translate-y-1/2 p-4 text-center xl:w-fit">
        <BrokenImageIcon color="core-gray-800" size={64} className="mx-auto md:hidden" />
        <BrokenImageIcon color="core-gray-800" size={144} className="mx-auto hidden md:block" />
        <ParagraphXL className="mb-4 w-full">
          {t(
            'unexpectedErrorLoadingLivestream',
            'There has been an unexpected error loading the livestream, please refresh to try again.',
          )}
        </ParagraphXL>
        <ParagraphLG>
          <Translate i18nKey="livestreamErrorInstructions" t={t}>
            If your problem persists,{' '}
            <a href={paths.external.zendesk.contactUs} className="bold text-oxide underline">
              contact us
            </a>
            .
          </Translate>
        </ParagraphLG>
      </div>
    </div>
  )
}
